import React, {useState} from "react";
import {Link} from "react-router-dom";

const Panel = ({children, element = 'h2', intro, link, open, title, page = '/'}) => {
    return (
        <div>
            {element === 'h2' && <h2 style={styles.header}>{title}</h2>}
            {element === 'h3' && <h3 style={styles.header}>{title}</h3>}


            {!open && <div>
                <p className={'text'}>{intro}</p>
                <Link to={page}>
                    <p style={styles.link}>{link}</p>
                </Link>
            </div>}

            {open && children}
        </div>
    );
}

const styles = {
    header: {
        cursor: 'pointer',
    },
    link: {
        cursor: "pointer",
        textDecoration: 'underline',
    }
}

export default Panel;
